// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LoginButton_button__1APvL {\n  display: flex;\n  margin-top: 20px;\n  justify-content: center;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Login/LoginButton.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".button {\n  display: flex;\n  margin-top: 20px;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "LoginButton_button__1APvL"
};
export default ___CSS_LOADER_EXPORT___;
